import Http from '@/services/httpAcademy'

export const listMentorshipOffers  = (params) => Http.get('/admin/mentorships/offers', { params })
export const listMentorshipSessions = (params) => Http.get('/admin/mentorships/sessions', { params })
